import script from "./SubHead.vue?vue&type=script&setup=true&lang=js"
export * from "./SubHead.vue?vue&type=script&setup=true&lang=js"

import "./SubHead.vue?vue&type=style&index=0&id=20880508&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20880508"]])

export default __exports__